module.exports = __webpack_public_path__ + "img/conveniencias-03.f095255d.png";